import { ThemeProvider } from "@emotion/react";
import { createTheme } from "@mui/material";
import { jwtDecode } from "jwt-decode";
import { SnackbarProvider } from "notistack";
import { useEffect, useRef } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
// import ResetPassword from "./common/components/ResetPassword";
import { useFrameBusting } from "./common/hooks/useFrameBusting";
import { getRoles } from "./common/utils/FunctionsUtils";
import globalRouter from "./common/utils/globalRouter";
import withTokenValidation from "./common/utils/withTokenValidation";
import Auth from "./modules/home/ui/Auth";
import Home from "./modules/home/ui/Home";
import ResetPassword from "./common/components/ResetPassword";

const theme = createTheme({
  palette: {
    primary: {
      main: "#25384a",
    },
    secondary: {
      main: "#25384a",
    },
  },
});

export const ModuleName = () => {
  const queryParameters = new URLSearchParams(window.location.search);
  return queryParameters.get("module");
};

function App() {
  const providerRef = useRef();
  const navigate = useNavigate();

  const roles = getRoles();
  const isAuthenticated = !!localStorage.getItem("token");

  useEffect(() => {
    if (isAuthenticated && typeof window.startWidget === "function") {
      window.startWidget({});
    }
  }, [isAuthenticated]);

  useEffect(() => {
    const queryParameters = new URLSearchParams(window.location.search);
    let token = queryParameters.get("token");
    if (token) {
      try {
        const decoded = jwtDecode(token);
        if (
          decoded?.roles?.some((role) =>
            [
              "ROLE_VUPORTUARIA_MEAD",
              "ROLE_VUPORTUARIA_COMPAGNIE_AERIENNE",
              "ROLE_VUPORTUARIA_ADMIN",
              "ROLE_VUPORTUARIA_OPERADOR",
              "ROLE_VUPORTUARIA_FACTURAS_CLIENTE",
              "ROLE_VUPORTUARIA_FACTURAS_EMISOR",
              "ROLE_VUPORTUARIA_FREIGHT_FORWARDER",
            ].includes(role),
          )
        ) {
          localStorage.setItem("token", token);
          localStorage.setItem("reportCereal", decoded.report_cereal);
          navigate("/home");
        } else {
          // setForbidden(true);
        }
      } catch (err) {
        // setForbidden(true);
      }
    }
  }, [navigate]);

  globalRouter.navigate = navigate;

  useFrameBusting();
  return (
    <SnackbarProvider maxSnack={3} ref={providerRef}>
      <ThemeProvider theme={theme}>
        {!isAuthenticated ? (
          <Routes>
            <Route path="/" element={<Auth />} />
            <Route path="/reset-password" element={<ResetPassword />} />
          </Routes>
        ) : (
          <Home roles={roles} token={localStorage.getItem("token")} />
        )}
      </ThemeProvider>
    </SnackbarProvider>
  );
}

export default withTokenValidation(App, ModuleName());
